/**
 * Redux Provider Adapter
 * 
 * Redux-specific provider implementation.
 * This is the only place where Redux Provider and PersistGate should be imported.
 */

import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import type { Store } from '@reduxjs/toolkit';
import type { Persistor } from 'redux-persist';
import { ReduxStoreAdapter } from './reduxAdapter';

/**
 * Redux-specific provider component
 * Wraps Redux Provider and PersistGate
 */
export function ReduxProviderAdapter<State = unknown>({
  store,
  persistor,
  children,
  loading,
}: {
  store: ReduxStoreAdapter<State>;
  persistor?: Persistor;
  children: React.ReactNode;
  loading?: React.ReactNode;
}): JSX.Element {
  const reduxStore = store.getReduxStore() as Store;

  if (persistor) {
    return (
      <ReduxProvider store={reduxStore}>
        <PersistGate loading={loading} persistor={persistor}>
          {children}
        </PersistGate>
      </ReduxProvider>
    );
  }

  return <ReduxProvider store={reduxStore}>{children}</ReduxProvider>;
}
